import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { companyAdminGuard } from './core/guards/company-admin.guard';
import { partyOwnerGuard } from './core/guards/party-owner.guard';

export const routes: Routes = [
  {
    // Landing page pública B2B: divulgação do produto para buffets
    path: 'para-buffets',
    loadComponent: () =>
      import('./landing/para-buffets/landing-buffets.component').then(
        (m) => m.LandingBuffetsComponent
      ),
  },
  {
    // Landing page pública B2C: RSVP avulso por evento para o cliente final
    path: 'para-festas',
    loadComponent: () =>
      import('./landing/para-festas/landing-festas.component').then(
        (m) => m.LandingFestasComponent
      ),
  },
  {
    path: 'auth/login',
    loadComponent: () =>
      import('./auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    // Solicita o e-mail com o link de recuperação de senha
    path: 'auth/recuperar-senha',
    loadComponent: () =>
      import('./auth/recuperar-senha/recuperar-senha.component').then(
        (m) => m.RecuperarSenhaComponent
      ),
  },
  {
    // Destino do link de recovery do Supabase: define a nova senha
    path: 'auth/redefinir-senha',
    loadComponent: () =>
      import('./auth/redefinir-senha/redefinir-senha.component').then(
        (m) => m.RedefinirSenhaComponent
      ),
  },
  {
    path: 'auth/aceitar-convite',
    loadComponent: () =>
      import('./auth/aceitar-convite/aceitar-convite.component').then(
        (m) => m.AceitarConviteComponent
      ),
  },
  {
    // Página pública do convite: convidado (não logado) confirma presença
    path: 'convite/:id',
    loadComponent: () =>
      import('./convite/convite.component').then((m) => m.ConviteComponent),
  },
  {
    path: 'admin',
    canActivate: [authGuard, adminGuard],
    loadComponent: () =>
      import('./admin/layout/admin-layout.component').then((m) => m.AdminLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./admin/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'empresas',
        loadComponent: () =>
          import('./admin/empresas/empresas.component').then((m) => m.EmpresasComponent),
      },
      {
        path: 'empresas/novo',
        loadComponent: () =>
          import('./admin/empresas/novo-empresa/novo-empresa.component').then((m) => m.NovoEmpresaComponent),
      },
      {
        path: 'empresas/:id',
        loadComponent: () =>
          import('./admin/empresas/detalhe-empresa/detalhe-empresa.component').then((m) => m.DetalheEmpresaComponent),
      },
      {
        // Suporte: admin acessa e gerencia os dados de um evento do buffet
        path: 'empresas/:id/eventos/:idEvento',
        loadComponent: () =>
          import('./admin/empresas/detalhe-evento/detalhe-evento.component').then((m) => m.DetalheEventoComponent),
      },
      {
        // Visão global de eventos de todos os buffets (suporte)
        path: 'eventos',
        loadComponent: () =>
          import('./admin/eventos/eventos.component').then((m) => m.AdminEventosComponent),
      },
      {
        path: 'usuarios',
        loadComponent: () =>
          import('./admin/usuarios/usuarios.component').then((m) => m.UsuariosComponent),
      },
      {
        path: 'usuarios/novo',
        loadComponent: () =>
          import('./admin/usuarios/novo-usuario/novo-usuario.component').then((m) => m.NovoUsuarioComponent),
      },
      {
        path: 'usuarios/:id',
        loadComponent: () =>
          import('./shared/components/detalhe-usuario/detalhe-usuario.component').then((m) => m.DetalheUsuarioComponent),
      },
      {
        path: 'faturamento',
        loadComponent: () =>
          import('./admin/faturamento/faturamento.component').then((m) => m.FaturamentoComponent),
      },
      {
        path: 'configuracoes',
        loadComponent: () =>
          import('./admin/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
    ],
  },
  {
    path: 'empresa',
    canActivate: [authGuard, companyAdminGuard],
    loadComponent: () =>
      import('./empresa/layout/empresa-layout.component').then((m) => m.EmpresaLayoutComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./empresa/visao-geral/visao-geral.component').then((m) => m.VisaoGeralComponent),
      },
      {
        path: 'calendario',
        loadComponent: () =>
          import('./empresa/calendario/calendario.component').then((m) => m.CalendarioComponent),
      },
      {
        path: 'usuarios',
        loadComponent: () =>
          import('./empresa/usuarios/usuarios.component').then((m) => m.EmpresaUsuariosComponent),
      },
      {
        path: 'usuarios/novo',
        loadComponent: () =>
          import('./admin/usuarios/novo-usuario/novo-usuario.component').then((m) => m.NovoUsuarioComponent),
      },
      {
        path: 'usuarios/:id',
        loadComponent: () =>
          import('./shared/components/detalhe-usuario/detalhe-usuario.component').then((m) => m.DetalheUsuarioComponent),
      },
      {
        path: 'configuracoes',
        loadComponent: () =>
          import('./empresa/configuracoes/configuracoes.component').then((m) => m.EmpresaConfiguracoesComponent),
      },
    ],
  },
  {
    path: 'cliente',
    canActivate: [authGuard, partyOwnerGuard],
    loadComponent: () =>
      import('./cliente/layout/cliente-layout.component').then((m) => m.ClienteLayoutComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'eventos',
      },
      {
        path: 'eventos',
        loadComponent: () =>
          import('./cliente/eventos/eventos.component').then((m) => m.EventosComponent),
      },
      {
        path: 'eventos/:id',
        loadComponent: () =>
          import('./cliente/evento-detalhe/evento-detalhe.component').then((m) => m.EventoDetalheComponent),
      },
      {
        path: 'configuracoes',
        loadComponent: () =>
          import('./cliente/configuracoes/configuracoes.component').then((m) => m.ClienteConfiguracoesComponent),
      },
      {
        path: 'configuracoes/senha',
        loadComponent: () =>
          import('./cliente/configuracoes/alterar-senha.component').then((m) => m.AlterarSenhaComponent),
      },
      {
        path: 'suporte',
        loadComponent: () =>
          import('./cliente/suporte/suporte.component').then((m) => m.SuporteComponent),
      },
    ],
  },
  {
    path: 'home',
    canActivate: [authGuard],
    loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
